import { useQuery } from "@tanstack/react-query";
import PageService from "services/PageService";

export const useFindPages = (params = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: ["findPages", params],
    queryFn: () => PageService.findPages(params),
    ...queryOptions,
  });
};

export const useFindPagesByTemplateKeys = (params = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: ["findPagesByTemplateKeys", params],
    queryFn: () => PageService.findPagesByTemplateKeys(params),
    ...queryOptions,
  });
};

export const useSearch = ({ query, lang, from, size }, queryOptions = {}) => {
  return useQuery({
    queryKey: ["search", query, lang, from, size],
    queryFn: () => PageService.search({ query, lang, from, size }),
    ...queryOptions,
  });
};

export const useGetPageInfos = (pathname = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getPageInfos", pathname],
    queryFn: () => PageService.getPageInfos(pathname),
    ...queryOptions,
  });
};

export const useGetTags = (params = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: ["getTags", params],
    queryFn: () => PageService.getTags(params),
    ...queryOptions,
  });
};

export const useFindHighlightNews = (params = {}, queryOptions = {}) => {
  return useQuery({
    queryKey: ["findHighlightNews", params],
    queryFn: () => PageService.findHighlightNews(params),
    ...queryOptions,
  });
};
